import { action } from 'satcheljs/lib/legacy';
import { FeedbackViewState } from '../store/schema/FeedbackViewState';

export default action('setFeedbackSubject')(function setFeedbackSubject(
    state: FeedbackViewState,
    subject: string
) {
    state.subject = subject || '';
});
